import * as React from 'react';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';
import PermMediaOutlinedIcon from '@mui/icons-material/PhotoSizeSelectActual';
import PublicIcon from '@mui/icons-material/Public';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import TimerIcon from '@mui/icons-material/Timer';
import SettingsIcon from '@mui/icons-material/Settings';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';


// my imports https://mui.com/material-ui/material-icons/?query=camera&selected=PhotoCameraFront
import PhotoCameraFrontIcon from '@mui/icons-material/PhotoCameraFront';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import InfoIcon from '@mui/icons-material/Info';
import CallIcon from '@mui/icons-material/Call';

import titles from '../titles.json';

const managerCategories = [
  {
    id: 'Services',
    children: [
      { id: titles.app.services.manager.leftNavigatorTabs[0], icon: <PeopleIcon />, active: true },
     //{ id: titles.app.services.admin. leftNavigatorTabs[1], icon: <PhotoCameraFrontIcon /> },
     // { id: titles.app.services.leftNavigatorTabs[2], icon: <SmartDisplayIcon /> },
     // { id: titles.app.services.leftNavigatorTabs[3], icon: <SettingsEthernetIcon /> },
     // { id: titles.app.services.leftNavigatorTabs[4], icon: <PublicIcon /> },
     // { id: titles.app.services.leftNavigatorTabs[5], icon: <SettingsInputComponentIcon /> },
    ],
  },
  {
    id: 'More',
    children: [
      { id: titles.app.more.leftNavigatorTabs[0], icon: <AccountBoxIcon /> },
      { id: titles.app.more.leftNavigatorTabs[1], icon: <CallIcon /> },
    ],
  },
];

const item = {
  py: '2px',
  px: 3,
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover, &:focus': {
    bgcolor: 'rgba(255, 255, 255, 0.08)',
  },
};

const itemCategory = {
  boxShadow: '0 -1px 0 rgb(255,255,255,0.1) inset',
  py: 1.5,
  px: 3,
};

export default function Navigator(props) {
  const [activeId, updateVisualSelectedId] = React.useState('Members');
  const { ...other } = props;

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem sx={{ ...item, ...itemCategory, fontSize: 22, color: '#fff' }}>
          Sports Streamer
        </ListItem>
        <ListItem sx={{ ...item, ...itemCategory }}>
          <ListItemIcon>
          </ListItemIcon>
          <ListItemText></ListItemText>
        </ListItem>
        {managerCategories.map(({ id, children }) => (
          <Box key={id} sx={{ bgcolor: '#101F33' }}>
            <ListItem sx={{ py: 2, px: 3 }}>
              <ListItemText sx={{ color: '#fff' }}>{id}</ListItemText>
            </ListItem>
            {children.map(({ id: childId, icon, active }) => (
              <ListItem disablePadding key={childId} onClick={() => {props.leftNavClicked(childId); updateVisualSelectedId(childId)}}>
                <ListItemButton selected={activeId == childId ? true : false} sx={item}>
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText>{childId}</ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
      </List>
    </Drawer>
  );
}
